"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./slider.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Slider = exports.Slider = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    minValue,
    maxValue,
    currentMin,
    currentMax,
    step = 1,
    onChange,
    minValueLabel,
    maxValueLabel,
    idPrefix,
    onEnd
  } = _ref;
  const [sliderMinValue, setSliderMinValue] = (0, _react.useState)(currentMin || minValue);
  const [sliderMaxValue, setSliderMaxValue] = (0, _react.useState)(currentMax || maxValue);
  const [zIndexMaxValueElement, setZIndexMaxValueElement] = (0, _react.useState)(3);
  const [zIndexMinValueElement, setZIndexMinValueElement] = (0, _react.useState)(5);
  (0, _react.useEffect)(() => {
    currentMin && setSliderMinValue(currentMin);
    currentMax && setSliderMaxValue(currentMax);
  }, [currentMin, currentMax]);
  const sliderRange = Array.from({
    length: maxValue
  }, (_, index) => index + minValue);
  const setZIndex = element => {
    if (element === "min") {
      setZIndexMinValueElement(zIndexMaxValueElement);
      setZIndexMaxValueElement(zIndexMinValueElement);
    } else if (element === "max") {
      setZIndexMaxValueElement(zIndexMinValueElement);
      setZIndexMinValueElement(zIndexMaxValueElement);
    }
  };
  const handleMinSliderChange = event => {
    const newValue = parseInt(event.target.value, 10);
    if (newValue <= sliderMaxValue) {
      setSliderMinValue(newValue);
      onChange(newValue, sliderMaxValue);
    }
  };
  const handleMaxSliderChange = event => {
    const newValue = parseInt(event.target.value, 10);
    if (newValue >= sliderMinValue) {
      setSliderMaxValue(newValue);
      onChange(sliderMinValue, newValue);
    }
  };
  const calculateRangeWidth = () => {
    const range = sliderMaxValue - sliderMinValue;
    const totalRange = maxValue - minValue;
    return "".concat(range / totalRange * 100, "%");
  };
  const calculateMargin = () => {
    return "".concat((sliderMinValue - minValue) / (maxValue - minValue) * 100, "%");
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "slider-container",
    ref: ref
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: "".concat(idPrefix || "", "filter-min-value"),
    className: "thumb right",
    type: "range",
    min: minValue,
    max: maxValue,
    step: step,
    value: sliderMinValue,
    onChange: handleMinSliderChange,
    onMouseDown: () => setZIndex("min"),
    style: {
      zIndex: zIndexMinValueElement
    },
    onMouseUp: () => onEnd && onEnd(),
    onKeyUp: e => onEnd && ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key) && onEnd()
  }), /*#__PURE__*/_react.default.createElement("input", {
    id: "".concat(idPrefix || "", "filter-max-value"),
    className: "thumb left",
    type: "range",
    min: minValue,
    max: maxValue,
    step: step,
    value: sliderMaxValue,
    onChange: handleMaxSliderChange,
    onMouseDown: () => setZIndex("max"),
    style: {
      zIndex: zIndexMaxValueElement
    },
    onMouseUp: () => onEnd && onEnd(),
    onKeyUp: e => onEnd && ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key) && onEnd()
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "slider"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "slider-track"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "slider-range",
    style: {
      width: calculateRangeWidth(),
      marginLeft: calculateMargin()
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "slider-values"
  }, sliderRange.map(value => /*#__PURE__*/_react.default.createElement("span", {
    key: value
  }, value))), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "".concat(idPrefix || "", "filter-min-value"),
    className: "slider-left-value"
  }, minValueLabel), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "".concat(idPrefix || "", "filter-max-value"),
    className: "slider-right-value"
  }, maxValueLabel)));
});